import { httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';
import { getFbFunctions } from './development';

export async function sendContactForm(
  { name, email, message, token }:
  { name: string, email: string, message: string, token: string },
) {
  const fbApp = getApp(this.firebaseApp);
  const functions = getFbFunctions(fbApp);

  try {
    // Verify captcha
    const contactForm = httpsCallable(functions, 'contactForm');
    const data = {
      name: name,
      email: email,
      message: message,
      token: token,
    };
    return await contactForm(data);
  } catch {
    return false;
  }
}
